import {
    faAnglesRight,
    faEllipsisV,
    faMinusCircle,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import {
    ButtonGroup,
    CardBody,
    CardTitle,
    CardSubtitle,
    CardFooter,
} from 'reactstrap';
import cls from 'classnames';
import { Weekdays } from '../Common';
import { isAttachedToLongTermScheduleCrew } from './LongTermScheduleDispatch';

export default class EquipmentCard extends React.Component {
    setRef = (ref) => {
        // keep a reference to the dom ref as an instance property
        this.ref = ref;
        // give the dom ref to @hello-pangea/dnd
        this.props.innerRef(ref);
    };

    isActiveForLongTermSchedule = (day) => {
        const { longTermSchedules, ltsCrews, equipment, weekdays } = this.props;

        if (
            !longTermSchedules ||
            !longTermSchedules.length ||
            !ltsCrews ||
            !equipment ||
            !equipment.id
        ) {
            return false;
        }

        const dayValue = day.id;
        const equipmentId = equipment.id;

        return isAttachedToLongTermScheduleCrew({
            longTermSchedules,
            ltsCrews,
            weekdays,
            dayValue,
            equipmentId,
        });
    };

    isActive = (day) => {
        const { equipment, allJobs } = this.props;
        const equipmentId = equipment.id;

        const dayId = day.id;

        if (this.isActiveForLongTermSchedule(day)) {
            return true;
        }

        return Boolean(
            allJobs.find((j) =>
                j.assignments[dayId].equipment.find(
                    (e) => e.assignment && e.assignment.id === equipmentId
                )
            )
        );
    };

    render() {
        const {
            equipment,
            provided,
            weekdays,
            hiddenEquipmentIds,
            equipmentGroups,
            removable,
        } = this.props;

        if (hiddenEquipmentIds.includes(equipment.id)) {
            return (
                <div
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    ref={this.setRef}
                />
            );
        }

        const equipmentGroup = equipmentGroups.find(
            (eg) => equipment.equipmentType.equipmentGroupId == eg.id
        );

        return (
            <div
                className={cls('card equipmentCard', {
                    compact: !!this.props.compact,
                    minimal: !!this.props.minimal,
                })}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
                ref={this.setRef}
            >
                <div className="dragIndicator">
                    <FontAwesomeIcon icon={faEllipsisV} />
                    <FontAwesomeIcon icon={faEllipsisV} />
                </div>
                <CardBody>
                    <CardTitle className="text-left d-flex flex-row justify-content-between align-items-center">
                        <div className="d-flex flex-row flex-fill flex-nowrap justify-space-between align-items-center">
                            <span className="flex-fill staff-name">
                                #{equipment.identifier} {equipment.description}
                            </span>
                        </div>
                        {Boolean(removable) && (
                            <FontAwesomeIcon
                                title="Remove this equipment"
                                icon={faMinusCircle}
                                className="text-danger cursor-pointer"
                                onClick={this.props.onRemoveClicked}
                            />
                        )}
                    </CardTitle>
                    <CardSubtitle className="mt-1 mb-1 text-muted d-flex flex-row justify-space-between align-items-start">
                        <label>{equipment.equipmentType.description}</label>
                        {Boolean(equipmentGroup) && (
                            <label className="ml-1">
                                <FontAwesomeIcon
                                    icon={faAnglesRight}
                                    className="mr-1"
                                />
                                {equipmentGroup.name}
                            </label>
                        )}
                    </CardSubtitle>
                    <CardFooter>
                        <ButtonGroup className="" size="sm">
                            {weekdays.map((dayDate) => {
                                const day = Weekdays.find(
                                    (x) => x.id === dayDate.getDay()
                                );

                                return (
                                    <span
                                        key={day.id}
                                        className={cls(
                                            'btn btn-sm btn-outline-secondary scheduledDayIndicator',
                                            {
                                                active: this.isActive(day),
                                            }
                                        )}
                                    >
                                        {day.abbreviationShort}
                                    </span>
                                );
                            })}
                        </ButtonGroup>
                    </CardFooter>
                </CardBody>
            </div>
        );
    }
}
